"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.activateUser = exports.signUp = void 0;
var axios_1 = __importDefault(require("axios"));
var catchAxiosError_1 = __importDefault(require("../util/catchAxiosError"));
function signUp(params) {
    return axios_1.default
        .post("https://".concat(process.env.REACT_APP_TRYBE_WP, "/wp-json/wp/v2/users/signup"), params)
        .catch(catchAxiosError_1.default);
}
exports.signUp = signUp;
function activateUser(params) {
    return axios_1.default
        .post("https://".concat(process.env.REACT_APP_TRYBE_WP, "/wp-json/wp/v2/users/activateuser"), params)
        .catch(catchAxiosError_1.default);
}
exports.activateUser = activateUser;
